const accordionItems = Array.from(document.querySelectorAll('.accordion-wrapper'));

// Open dropdown menu
const openAccordionItem = (el) => {
    if (el.classList.contains("open-accordion")) {
        el.classList.remove("open-accordion");
        el.querySelector('.accordion-title').setAttribute('aria-expanded', "false");
    } else {
        accordionItems.forEach(el => el.classList.remove("open-accordion"));
        el.classList.add("open-accordion");
        el.querySelector('.accordion-title').setAttribute('aria-expanded', "true");
    }
}

const openAccordionById = (id) => {
    const item = accordionItems.find(el => el.id === id);
    if (item) {
        openAccordionItem(item);
    }
}

// Add event listeners for click and keyboard
accordionItems.forEach(el => {
    const title = el.querySelector('.accordion-title');
    if (title) {
        title.addEventListener('click', () => openAccordionItem(el));
        title.addEventListener('keydown', function(e) {
            if (e.code === 'Enter' || e.code === 'Space') {
                e.preventDefault();
                openAccordionItem(el);
            }
        });
    }
});

// Open accordion if a hash is present in the URL
const hash = window.location.hash;
if (hash) {
    openAccordionById(hash.substring(1));
}

// Add event listener for all links on the page
Array.from(document.querySelectorAll('a')).forEach(link => {
    link.addEventListener('click', event => {
        const href = link.getAttribute('href');
        if (href && href.startsWith('#')) {
            const accordionId = href.substring(1);
            const accordionElement = document.getElementById(accordionId);
            if (accordionElement && accordionElement.classList.contains('accordion-wrapper')) {
                event.preventDefault();
                accordionElement.scrollIntoView({ behavior: 'smooth' });
                setTimeout(() => {
                    openAccordionById(accordionId);
                }, 300); // Adjust the timeout as needed
            } // If it's not an accordion, the default action is not prevented
        }
    });
});
